<svelte:head>
  <title>Delete Account | A Good Thing</title>
</svelte:head>

<div class="block">
  <div class="notification is-danger is-light">
    WARNING: This action cannot be undone
  </div>
</div>

<div class="field is-horizontal">
  <div class="block">
    <div class="control">
      <button class="button is-primary" on:click={() => {
          $uiState.activeModal = {
            component: ConfirmDeleteUser,
            props: { userId, gotoPath: '/goodbye' }
          };
        }}>Confirm Delete</button>
    </div>
  </div>
</div>

<script lang="ts">
  import _ from 'lodash';
  import { appState } from '../../../lib/appState';
  import { uiState } from '../../../lib/uiState';
  import ConfirmDeleteUser from './_components/ConfirmDeleteUser.svelte';

  let data = _.cloneDeep($appState.auth_user);

  let userId = data.email

</script>
